import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import {
    GetEnumElementByIndex,
    GetNextEnumValue,
    GetPreviousEnumValue,
} from "motw_core/Utils/EnumUtils";
import { ChangeTreeBranch } from "source/app/presentation/BottomBar/BottomLeftDashboard/Stack/ChangeTreeBranch";
import { EStackFocus } from "source/app/presentation/MainPanel/Dreams/EStackFocus";
import {
    IKeyboardEvent,
    TKeyboardEvent,
} from "source/app/services/UI/KeyboardEvents/IKeyboardEvents";
import { ReadState } from "../../../State/ReadState";

export const IncreaseTreeBranch: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + Shift + Up`,
    actionDescription: `Increase tree branch`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.shiftKey && event.keyCode == 38,
    action: () => {
        // const currEnumIndexString = ReadState<IKeyValue>(
        //     ESharedFunction.StackFocus_currentStackFocus
        // )!.value;

        // const currentEnumIndex = Number.parseInt(currEnumIndexString);

        // const currentEnumValue = GetEnumElementByIndex(
        //     EStackFocus,
        //     currentEnumIndex
        // );

        // const nextStackFocus = GetPreviousEnumValue(
        //     EStackFocus,
        //     currentEnumValue
        // );

        // ChangeTreeBranch(nextStackFocus);
    },
};

export const ReduceTreeBranch: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + Shift + Down`,
    actionDescription: `Reduce tree branch`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.shiftKey && event.keyCode == 40,
    action: () => {
        // const currEnumIndexString = ReadState<IKeyValue>(
        //     ESharedFunction.StackFocus_currentStackFocus
        // )!.value;

        // const currentEnumIndex = Number.parseInt(currEnumIndexString);

        // const currentEnumValue = GetEnumElementByIndex(
        //     EStackFocus,
        //     currentEnumIndex
        // );

        // const nextStackFocus = GetNextEnumValue(EStackFocus, currentEnumValue);

        // ChangeTreeBranch(nextStackFocus);
    },
};
